import React, { useCallback, useEffect, useState } from 'react';
import { Page, PageNavigation } from '@ui/components';
import { getCities, ICity } from '@ui/api/v2/cities.api';

import CityCard from './CityCard';

import './Cities.less';
import CityForm from './CityForm';

export function Cities() {
  const [cities, setCities] = useState<ICity[]>([]);

  const [editCity, setEditCity] = useState<ICity>();

  const fetchCities = useCallback(async () => {
    const { data } = await getCities();
    if (data) {
      setCities(data);
    }
  }, []);

  useEffect(() => {
    void fetchCities();
  }, [fetchCities]);

  const resetEditCity = useCallback(() => {
    setEditCity(undefined);
  }, []);

  const onCityCreate = useCallback((market: ICity) => {
    setCities(m => [...m, market]);
  }, []);

  const onCityUpdate = useCallback((city: ICity) => {
    setCities(c =>
      c.map(m => {
        if (m.id === city.id) {
          return city;
        }
        return m;
      }),
    );
  }, []);

  const onMarketDelete = useCallback((cityId: number) => {
    setCities(c => c.filter(m => m.id !== cityId));
  }, []);

  return (
    <div className="cities">
      <PageNavigation title="Города" />
      <Page>
        <Page.LeftSide>
          <CityForm
            city={editCity}
            onCityCreate={onCityCreate}
            onCityUpdate={onCityUpdate}
            resetEditCity={resetEditCity}
          />
        </Page.LeftSide>
        <Page.Content>
          <div className="cities__wrapper">
            {[...cities]
              .sort((a, b) => (a.name < b.name ? -1 : 1))
              .map(m => (
                <CityCard
                  key={m.id}
                  city={m}
                  setEditCity={setEditCity}
                  onDelete={onMarketDelete}
                />
              ))}
          </div>
        </Page.Content>
      </Page>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cities/Cities.tsx